var _image;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkAsResolvedDarkMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABpklEQVR4nN1USU7EQAyMkOACSMAngD+wDDyATYgXIF7AH1i+wfIHEAfgyBmxc+Ey6ip7JgLuQTUT0BASkswNSmop6XaX3XbZUfSvkSTJEOAbpB0Dfkf6u1b3u7O3IZu+yM1sjbRnwE8A3yQ52Ww2h7VITmkP8FPSnsxstU7UA4DtK0qgNVtmLxvS7wHb091SByIn7bzdbo9VDSqO43HSLuSkNC2KvA75dyf+QHIlyoOKpXySbER9AmjNqW65hZciVLR+yT8B+FkIth5lkcpuM6oBoDUP2PV3Ht8C7DDHgd9LinXISQ/ZlKYSvstz8BZCGKlCHkJrJiVf/HkWRsSVE5G/khzN7F1lIyyKvOcFo+KqlCKR9JJl/wsc5KcIsKO8IvOL1LdJQ5mM0yIf1JIpyQZgL1V6pFCmSZIMkv5IcqGMpAjd+hQ0mqCpqPyp7aOaiON4Ih0VS78aamBpcNVxEnfI7RKwnarjei+NplFmr5TKFrDdSuO65+KKaqKiSRlmNq0m0tJ3Vy2dMwWyXJk485pBKUKzBfBbdagW4DeSos5k0xf5n8EHQAj2euSXlSAAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkAsResolvedDarkMode);
export default __webpack_public_path__ + "static/media/mark_as_resolved_dark_mode.eaffe95d960d1cf680b673d434552d19.svg";
export { ForwardRef as ReactComponent };